import { render, staticRenderFns } from "./MemberAreaGroups.vue?vue&type=template&id=92e2898a&scoped=true&"
import script from "./MemberAreaGroups.vue?vue&type=script&lang=js&"
export * from "./MemberAreaGroups.vue?vue&type=script&lang=js&"
import style0 from "./MemberAreaGroups.vue?vue&type=style&index=0&id=92e2898a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92e2898a",
  null
  
)

export default component.exports